module.exports = __webpack_public_path__ + "static/media/charles01.c41005f0.jpg";